import type {
    JobSeekerProfileStructuredDataSalaryType,
    JobSeekerProfileStructuredDataSentiment,
} from '../../../../../../../../__generated__/types.gqlgenerated';

import { useAddMinimumPayPreferenceMutation } from './__generated__/useAddMinimumPayPreference.gqlgenerated';

import { useCallback } from 'react';

export function useAddMinimumPayPreference() {
    const [addMinimumPayPreferenceMutation] = useAddMinimumPayPreferenceMutation();
    return useCallback(
        async (variables: {
            salaryType: JobSeekerProfileStructuredDataSalaryType;
            currency: string;
            amount: number;
            sentiment: JobSeekerProfileStructuredDataSentiment;
        }) => {
            const { data } = await addMinimumPayPreferenceMutation({ variables });
            const preference = data?.addJobSeekerProfileStructuredDataPreference?.preference;
            if (!preference || !preference.id) {
                throw new Error('add minPay call returned no data');
            }
            return preference;
        },
        [addMinimumPayPreferenceMutation],
    );
}
